import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3388c386")

_pushScopeId("data-v-3388c386")
const _hoisted_1 = {
  key: 0,
  class: "flex admin-panel-card-upgrade__list items-start"
}
const _hoisted_2 = { class: "mr4" }
const _hoisted_3 = { class: "mt3" }
const _hoisted_4 = { class: "h4 mb2" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "input-wrapper mr2" }
const _hoisted_7 = { class: "input-wrapper mr2" }
const _hoisted_8 = { class: "h3 mb2" }
const _hoisted_9 = { class: "board-card board-card--big" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_BoardCardDescription = _resolveComponent("BoardCardDescription")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t(`adminPanel.businessGame.cardUpgrade.title`)
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          class: "ml3",
          onClick: $setup.saveCardUpgradeConfig
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`adminPanel.businessGame.cardUpgrade.save`)), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_BaseBox, {
      class: "admin-panel-card-upgrade__box",
      saving: $setup.saveLoading
    }, {
      default: _withId(() => [
        ($setup.upgradeConfig && $setup.cardPreviewed)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("p", null, _toDisplayString(_ctx.$t(`adminPanel.businessGame.cardUpgrade.description`)), 1),
                _createVNode("div", _hoisted_3, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.upgradeConfig, (value, key) => {
                    return (_openBlock(), _createBlock("div", {
                      key: key,
                      class: "mb2"
                    }, [
                      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`adminPanel.businessGame.cardUpgrade.${key}`)), 1),
                      _createVNode("div", _hoisted_5, [
                        _createVNode("div", _hoisted_6, [
                          _createVNode("label", null, _toDisplayString(_ctx.$t(`adminPanel.businessGame.cardUpgrade.english`)), 1),
                          _createVNode(_component_Input, {
                            modelValue: value.en,
                            "onUpdate:modelValue": ($event: any) => (value.en = $event),
                            class: "p-inputtext-sm"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createVNode("div", _hoisted_7, [
                          _createVNode("label", null, _toDisplayString(_ctx.$t(`adminPanel.businessGame.cardUpgrade.polish`)), 1),
                          _createVNode(_component_Input, {
                            modelValue: value.pl,
                            "onUpdate:modelValue": ($event: any) => (value.pl = $event),
                            class: "p-inputtext-sm"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`adminPanel.businessGame.cardUpgrade.preview`)), 1),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_BoardCardDescription, _mergeProps($setup.cardPreviewed, {
                    big: true,
                    "upgrade-config": $setup.upgradeConfig
                  }), null, 16, ["upgrade-config"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["saving"])
  ], 64))
})